// extracted by mini-css-extract-plugin
module.exports = {"slumVille":"slumVille_slumVille__mmNka","circle":"slumVille_circle__We_61","ifFalse":"slumVille_ifFalse__Tdyz3","ifTrue":"slumVille_ifTrue__CaR77"};